import { theme } from '../../../styles/theme';
import { useIsMobile } from '../../../hooks/useIsMobile';
import connieRelaxingBeach from '../../../assets/connie-relaxing-beach-no-bckgn.png';
import type { FormData } from '../../../types';
import { CtaButton } from './shared';

const BUDGET_OPTIONS = [
  { id: 'mid',    label: 'Original', desc: 'Unique accommodation and local restaurants', icon: '◈◈◈' },
  { id: 'luxury', label: 'Prestige', desc: 'Luxury resorts and iconic dining', icon: '◈◈◈◈◈' },
] as const;

interface Props { form: FormData; onChange: (f: keyof FormData, v: unknown) => void; onNext: () => void; onBack?: () => void; }

export function StepBudget({ form, onChange, onNext, onBack }: Props) {
  const mobile = useIsMobile();
  const f = mobile ? theme.form.mobile : theme.form;
  const handleSelect = (id: string) => onChange('budget', id);
  const currentBudget = form.budget;

  return (
    <div style={{ maxWidth: mobile ? '100%' : 'min(80%, 700px)', margin: '0 auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: theme.spacing.md, marginBottom: mobile ? theme.spacing['2xl'] : theme.spacing['4xl'] }}>
        <img src={connieRelaxingBeach} alt="Connie" referrerPolicy="no-referrer"
          style={{ width: 'auto', height: mobile ? 'min(12vh, 100px)' : 'min(20vh, 250px)', objectFit: 'contain' }}
          onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
        <div>
          <h2 style={{ fontFamily: theme.fontFamily.display, fontSize: f.headingSize, fontWeight: theme.fontWeight.light, color: theme.colors.navy, margin: 0, letterSpacing: '-0.02em', textAlign: 'center' }}>
            "Your style of{' '}
            <span style={{ fontFamily: theme.fontFamily.serif, fontStyle: 'italic', fontWeight: 'bold', color: theme.colors.teal }}>luxury.</span>"
          </h2>
          <p style={{ color: theme.colors.textMuted, fontSize: f.subtitleSize, fontWeight: theme.fontWeight.light, margin: `${theme.spacing.xs} 0 0`, textAlign: 'center' }}>
            Do you prefer independent places or big-name luxury?
          </p>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
        {BUDGET_OPTIONS.map(({ id, label, desc, icon }) => {
          const active = currentBudget === id;
          return (
            <button key={id} type="button" onClick={() => handleSelect(id)}
              className={active ? 'chip-pop' : ''}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: `${theme.spacing.xl} ${theme.spacing['2xl']}`,
                borderRadius: theme.borderRadius['2xl'],
                border: `2px solid ${active ? theme.colors.teal : theme.colors.border}`,
                background: active ? theme.colors.teal : theme.colors.white,
                boxShadow: theme.shadows.card,
                cursor: 'pointer', transition: 'all 0.15s', textAlign: 'left',
              }}>
              <div>
                <div style={{ fontSize: theme.fontSize.md, fontWeight: theme.fontWeight.bold, color: active ? theme.colors.white : theme.colors.navy, marginBottom: 2 }}>{label}</div>
                <div style={{ fontSize: theme.fontSize.base, color: active ? theme.colors.whiteAlpha60 : theme.colors.textMuted }}>{desc}</div>
              </div>
              <span style={{
                fontSize: '1.4rem', letterSpacing: '0.1em',
                color: active ? theme.colors.whiteAlpha60 : theme.colors.gray300,
                fontWeight: theme.fontWeight.bold, flexShrink: 0, marginLeft: theme.spacing.lg,
              }}>{icon}</span>
            </button>
          );
        })}
      </div>

      <CtaButton
        label={currentBudget ? 'Continue' : 'Pick one to continue'}
        onClick={onNext}
        disabled={!currentBudget}
        onBack={onBack}
      />
    </div>
  );
}
